export default __webpack_public_path__ + "static/media/5.d1652f27.jpg";